// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/services/patient.service.ts"
);
import.meta.hot.lastModified = "1793805666629.077";
}
// REMIX HMR END

import { apiGet } from "./drupal.server.ts";
import {apiPost} from "./fetch.service.ts";
import merge  from "deepmerge";
import {isUndefined} from 'lodash'

export async function getPatientsData(request: Request, filters: any = {}) {
  const options  = merge(filters, {
      include: "facility,path,program,field_activities",
    })
  return await apiGet(request, 'nexus_patient--nexus_patient', options, true)
}

export async function getPatientData(request: Request, id: string, extraOptions: Record<string, any> = {}) {
  const results = await apiGet(request, 'nexus_patient--nexus_patient', merge({
    filter: {
      id: id
    },
    page: {
      offset: 0,
      limit: 1,
    },
    include: "facility,path,program,field_activities,field_devices",
    fields: {
      "device--ventilator": "label,serial,remote_integration,remote_id,status"
    },
    'extra-filter': 'assessment_latest',
  }, extraOptions), false)
  if (isUndefined(results)) {
    return null
  }
  if (results.count == 0) {
    return null
  }
  return results.data[0]
}

export async function getPatientDataByEntityId(request: Request, id: string) {
	const results = await apiGet(
		request,
		'nexus_patient--nexus_patient',
		{
			filter: {
				drupal_internal__id: id,
			},
			page: {
				offset: 0,
				limit: 1,
			},
		},
		false,
	)
	if (isUndefined(results)) {
		return null
	}
	if (results.count == 0) {
		return null
	}
	return results.data[0]
}

export async function savePatientData(patientId: any, request: Request) {
  //TODO add format for saving patient
  return await apiPost('api/patient', request);
}

export async function getPatientPrograms(request: Request) {
  const results = await apiGet(request, 'taxonomy_term--program', {
    page: {
      offset: 0,
      limit: 50,
    },
    fields: {
      'taxonomy_term--program': 'name,drupal_internal__tid'
    }
  }, true)

  if (isUndefined(results)) {
    return null
  }
  if (results.count == 0) {
    return null
  }

  const programs = results.data.map((p) => {
    return {
      label: p.name,
      value: p.id,
      tid: p.drupal_internal__tid
    }
  })
  return programs
}
export const patient_care_levels: any[] = [
	{
		label: 'Asthma',
		value: '4a7a2ae7-e8b2-406c-a3e7-8420ddeb4f44',
		classname: '',
	},
	{
		label: 'Home High Risk',
		value: 'aae1dc90-1239-4b6e-8fd3-837a221fbf4c',
		classname: '',
	},
	{
		label: 'Home Low Risk',
		value: 'c18a77e7-ad7c-4b4b-b63d-ee156a1922ad',
		classname: '',
	},
	{
		label: 'Hospital High Risk',
		value: 'ed2947ae-529d-4d78-8a1e-6f2823734b23',
		classname: '',
	},
	{
		label: 'Hospital Low Risk',
		value: 'd82f335b-aa1a-48cb-85be-4522e17b6454',
		classname: '',
	},
	{
		label: 'Clinical Respiratory',
		value: '2549493e-c286-4d8b-84df-a5a16990e8f3',
		classname: '',
	},
	{
		label: 'Long Term Care',
		value: '6841208c-25d0-4952-977d-af3af5c92b1b',
		classname: '',
	},
	{
		label: 'Maintenance',
		value: '56aaf7e5-943a-4fc9-91c5-ff2739fdcb8f',
		classname: '',
	},
	{
		label: 'PIC',
		value: 'ab32aa2d-e8ab-4034-8994-011391ad4447',
		classname: '',
	},
	{
		label: 'Trach',
		value: '7bee5307-535a-4050-bf71-bf0a280dab84',
		classname: '',
	},
]
export const patient_status: any[] = [
  {
    label: 'Pending',
    value: 0,
    className: 'bg-red-500 text-white'
  },
  {
    label: 'Active',
    value: 1,
    className: 'bg-green-500 text-white'
  },
  {
    label: 'Discharged',
    value: 2,
    className: 'bg-slate-600 text-white'
  },
  {
    label: 'Readmitted',
    value: 3,
    className: 'bg-yellow-600 text-white'
  },
  {
    label: 'Opt Out',
    value: 4,
    className: 'bg-slate-700 text-white'
  },
  {
    label: 'Maintenance',
    value: 5,
    className: 'bg-purple-600 text-white'
  },
  {
    label: 'SNF',
    value: 6,
    className: 'bg-pink-600 text-white'
  },
  {
    label: 'Hospice',
    value: 7,
    className: 'bg-blue-600 text-white'
  }
]

export const patient_payors: any[] = [
  {
    label: 'None',
    value: 'none',
    className: ''
  },
  {
    label: 'Medicare',
    value: 'medicare',
    className: ''
  },
  {
    label: 'Medicare HMO/Advantage',
    value: 'medicare_2',
    className: ''
  },
  {
    label: 'Commercial PPO/Other',
    value: 'commercial',
    className: ''
  },
  {
    label: 'Medicaid',
    value: 'medicaid',
    className: ''
  },
  {
    label: 'Medicaid MCO',
    value: 'medicaid_2',
    className: ''
  },
  {
    label: 'Other Payor plan',
    value: 'other',
    className: ''
  },
]

export const patient_payor_contract_statuses: any[] = [
	{
		label: 'Humana CAP transfer',
		value: 'humana_cap_transfer',
		className: '',
	},
	{
		label: 'Humana CAP new patient',
		value: 'humana_cap_new',
		className: '',
	},
	{
		label: 'Other Payor or Name of Plan transfer',
		value: 'other',
		className: '',
	},
]

// Resolve a stored field_coverage payor value to its display label, falling
// back to the raw value when it isn't one of the canonical option keys. Legacy
// free-text values (e.g. 'Medicare Part B') were copied verbatim into the
// composite by ingestion and must remain visible rather than render blank.
export function getPayorLabel(value: string): string {
	if (!value) return ''
	return patient_payors.find(p => p.value == value)?.label ?? value
}

export function getPayorContractStatusLabel(value: string): string {
	if (!value) return ''
	return (
		patient_payor_contract_statuses.find(p => p.value == value)?.label ?? value
	)
}

// Ensure a stored payor / contract-status value that isn't a canonical option
// key is still selectable in an edit <select>. Prepends the raw value as a
// selectable option marked as legacy, so the user can keep it (round-trips
// unchanged) or pick a canonical option.
export function withInjectedLegacyOption(options: any[], value: string): any[] {
	if (!value || options.some(o => o.value == value)) return options
	return [{ label: `${value} (legacy value)`, value }, ...options]
}

export const patient_types: any[] = [
  {
    label: 'Other',
    value: 0,
    className: 'danger',
    bg: 'bg-red-600 text-white'
  },
  {
    label: 'Invasive',
    value: 1,
    className: 'warning',
    bg: 'bg-amber-400'
  },
  {
    label: 'NonInvasive',
    value: 2,
    className: 'info',
    bg: 'bg-violet-500 text-white'
  },
  {
    label: 'Oxygen',
    value: 3,
    className: 'success',
    bg: 'bg-blue-400 text-white'
  },
  {
    label: 'Trach',
    value: 4,
    className: '',
    bg: 'bg-lime-400 text-black'
  },
  {
    label: 'Vest',
    value: 5,
    className: '',
    bg: 'bg-stone-400 text-black'
  },
  {
    label: 'Nebulizer',
    value: 6,
    className: '',
    bg: ''
  },
  {
    label: 'PAP',
    value: 7,
    className: '',
    bg: ''
  },
  {
    label: 'BiLevel Trial',
    value: 8,
    className: '',
    bg: ''
  },
  {
    label: 'SNF based PIC',
    value: 9,
    className: '',
    bg: ''
  },
  {
    label: 'SNF based Long Term Care',
    value: 10,
    className: '',
    bg: ''
  },
]

